import constants from '../../constants/app-constants';

export const populateWithdrawalRequests = (requests) => {
  return {
    type: constants.admin.WITHDRAWALREQUESTS_POPULATE,
    payload: requests
  };
};